import { Component, Input } from "@angular/core";

@Component({
  selector: "rc-full-screen-picture-modal",
  templateUrl: "./full-screen-picture-modal.component.html",
  styleUrls: ["./full-screen-picture-modal.component.scss"],
  standalone: false,
})
export class FullScreenPictureModalComponent {
  @Input() public description: string | undefined;
  @Input() public src: string;

  constructor() {}
}
